export default __webpack_public_path__ + "55e08f436e79fb4dd1d1786a2b2294d7.png";